(() => {
  if (customElements.get('vanemar-faq')) return;

  customElements.define('vanemar-faq', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.groups = [...this.querySelectorAll('[data-faq-group]')];
      this.links = [...this.querySelectorAll('[data-faq-nav]')];
      this.openHash = () => {
        let id;
        try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target || !this.contains(target)) return;
        if (target.matches('details')) target.open = true;
        this.activate(target.closest('[data-faq-group]')?.id || target.id);
      };
      this.openHash();
      window.addEventListener('hashchange', this.openHash, { signal });
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (link) this.activate(link.getAttribute('href').slice(1));
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('details');
        if (item) {
          item.open = true;
          item.scrollIntoView({ block: 'center' });
          this.activate(item.closest('[data-faq-group]')?.id);
        }
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const visible = entries.filter(entry => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (visible[0]) this.activate(visible[0].target.id);
        }, { rootMargin: '-15% 0px -55% 0px' });
        this.groups.forEach(group => this.observer.observe(group));
      }
    }

    activate(id) {
      this.links.forEach(link => {
        if (link.hash === `#${id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
})();
